import { Reviewer } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAvailableNominationReviewers: (
  fetchContext: FetchContext,
  nominationId: number,
  accessToken?: string,
) => Promise<Reviewer[]> = (fetchContext, nominationId, accessToken) => fetch(`${fetchContext.baseUrl}/api/admin/nominations/${nominationId}/reviewers`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<Reviewer[]>(fetchContext.errorStore, response, 'get available nomination reviewers'));
